import crud from '@/crud/index/index'
import resources from '../../resources'
import components from './components'

import computed from './computed'
import data from './data'
import methods from './methods'

export default {
  computed,
  data,
  methods,
  components,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/index/resources/index.js